export const getActivityMerchandiseList = {
  url: '/admin/activity/getActivityMerchandiseList.json',
  method: 'get'
};
export const getGroupActivityMerchandiseList = {
  url: '/admin/activity/group/getGroupActivityMerchandiseList.json',
  method: 'get'
};
export const activityUpdate = {
  method: 'post',
  url: '/admin/activity/redPacket/insertOrUpdateActivityInfo.json'
};
export const getRedPacketList = {
  method: 'get',
  url: '/admin/activity/getActivityListByActivityType.json'
};
export const removeActivity = {
  method: 'post',
  url: '/admin/activity/deleteActivity.json',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};
export const endActivity = {
  method: 'post',
  url: '/admin/activity/earlyEndActivity.json',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};
export const getActivityInfo = {
  method: 'get',
  url: '/admin/activity/redPacket/getActivityInfoById.json'
};
export const getActivityWithdrawList = {
  method: 'get',
  url: '/admin/activity/redPacket/getActivityWithdrawRecordList.json'
};
export const exportActivityWithdrawList = {
  method: 'get',
  url: '/admin/activity/redPacket/exportActivityWithdrawRecordList.json'
};
export const activityBuygiveUpdate = {
  method: 'post',
  url: '/admin/activity/buyGive/insertOrUpdateActivityInfo.json'
};
export const activityGroupUpdate = {
  method: 'post',
  url: '/admin/activity/group/insertOrUpdateActivityInfo.json'
};
export const getActivityBuygiveInfo = {
  method: 'get',
  url: '/admin/activity/buyGive/getActivityInfoById.json'
};
export const getActivityGroupInfo = {
  method: 'get',
  url: '/admin/activity/group/getActivityInfoById.json'
};

export const getGroupActivityEditRecordList = {
  method: 'get',
  url: '/admin/activity/group/getActivityEditRecordList.json'
};

export const getGroupActivityEditRecordDetail = {
  method: 'get',
  url: '/admin/activity/group/getActivityEditRecordDetail.json'
};

export const getActivityEditRecordList = {
  method: 'get',
  url: '/admin/activity/buyGive/getActivityEditRecordList.json'
};

export const getActivityEditRecordDetail = {
  method: 'get',
  url: '/admin/activity/buyGive/getActivityEditRecordDetail.json'
};

export const getActivityInfoByProdNo = {
  method: 'get',
  url: '/admin/activity/buyGive/getActivityInfoByProdNo.json'
};

export const getBranchInfoBySupplierId = {
  method: 'get',
  url: '/admin/activity/getBranchInfoListBySupplierId.json'
};

export const getVoteActivityList = {
  url: '/admin/activity/vote/pageList',
  method: 'get'
};

export const delVoteActivity = {
  url: '/admin/activity/deleteActivity.json',
  method: 'post'
};

export const saveVoteActivity = {
  url: '/admin/activity/vote/saveOrUpdate',
  method: 'post'
};

export const getPrizeManageList = {
  method: 'get',
  url: '/admin/activity/prizeManage/getPrizeList.json'
};

export const getPrizeMerchandiseList = {
  method: 'get',
  url: '/admin/activity/prizeManage/getPrizeMerchandiseList.json'
};

export const savePrizeManage = {
  method: 'post',
  url: '/admin/activity/prizeManage/savePrize.json'
};

export const deletePrizeManage = {
  method: 'post',
  url: '/admin/activity/prizeManage/deletePrize.json'
};

export const addPrizeCount = {
  method: 'post',
  url: '/admin/activity/prizeManage/addPrizeCount.json'
};

export const updatePrizePrice = {
  method: 'post',
  url: '/admin/activity/prizeManage/updatePrizePrice.json'
};

export const getPrizeEditRecordList = {
  method: 'get',
  url: '/admin/activity/prizeManage/getPrizeEditRecordList.json'
};

export const getPrizeExpireList = {
  method: 'get',
  url: '/admin/activity/prizeManage/getPrizeExpireList.json'
};

export const deductPrizeCount = {
  method: 'post',
  url: '/admin/activity/prizeManage/deductPrizeCount.json'
};

export const importPrizeManage = {
  method: 'post',
  url: '/admin/activity/prizeManage/importPrize'
};

export const exportPrizeManageList = {
  method: 'get',
  url: '/admin/activity/prizeManage/exportPrizeList.json'
};

export const getLevelOneSupplierList = {
  method: 'get',
  url: '/admin/split/rule/getLevelOneSupplierList.json'
};
